import { useState } from 'react';
import { Menu, Bell } from 'lucide-react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthContext';
import { notificationsApi } from '../api/notifications';
import { formatRelativeTime } from '../lib/format';

export function Topbar({ onToggleSidebar }: { onToggleSidebar: () => void }) {
  const { user } = useAuth();
  const [notifOpen, setNotifOpen] = useState(false);
  const queryClient = useQueryClient();

  // Real unread count from the actual notifications table via the new
  // GET /api/notifications/mine endpoint - never a hard-coded number.
  const notificationsQuery = useQuery({
    queryKey: ['notifications-mine'],
    queryFn: () => notificationsApi.mine(),
    refetchInterval: 60_000,
  });

  const markReadMutation = useMutation({
    mutationFn: (id: number) => notificationsApi.markRead(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications-mine'] }),
  });

  const unreadCount = notificationsQuery.data?.unreadCount ?? 0;

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button className="icon-button" onClick={onToggleSidebar} aria-label="Toggle sidebar">
          <Menu size={20} />
        </button>
        <div className="topbar-title">VConnect - Verdantrise Humanitarian Initiative</div>
      </div>
      <div className="topbar-user">
        <div className="notification-wrapper">
          <button className="icon-button" onClick={() => setNotifOpen((v) => !v)} aria-label="Notifications">
            <Bell size={20} />
            {unreadCount > 0 && <span className="notification-badge">{unreadCount > 9 ? '9+' : unreadCount}</span>}
          </button>
          {notifOpen && (
            <div className="notification-dropdown">
              <div className="notification-dropdown-header">Notifications</div>
              {notificationsQuery.data && notificationsQuery.data.data.length === 0 && (
                <div className="notification-empty">You're all caught up.</div>
              )}
              {notificationsQuery.data?.data.map((n) => (
                <button key={n.id} className="notification-item" onClick={() => markReadMutation.mutate(n.id)}>
                  <div className="notification-item-title">{n.title}</div>
                  <div className="notification-item-message">{n.message}</div>
                  <div className="notification-item-time">{formatRelativeTime(n.created_at)}</div>
                </button>
              ))}
            </div>
          )}
        </div>
        {user && <span>{user.fullName}</span>}
        <a href="/auth/logout">Sign out</a>
      </div>
    </header>
  );
}
